<script>
import { asyncAngularInvoke } from "/vodalys/vvuejs";
export default {
  translate25Context: "vrun_form",
  components: {},
  methods: {
    more: function () {
      var _zis = this;
      this.pending = true;
      this.handler.action(this.component["#id"], "load_more").then(function () {
        _zis.pending = false;
      });
    },
    removeAll: function () {
      var _zis = this;
      asyncAngularInvoke(function ($rootScope, $rootElement, v17Modal) {
        v17Modal.yesNo($rootScope, $rootElement.find("body"), {
          title: _zis.$vt("Remove all?"),
          message: _zis.$vt(
            "Are you sure you want to remove all items? This action cannot be undone."
          ),
          yesType: "negative",
          yesLabel: _zis.$vt("Remove all"),
          yes: function (input) {
            return _zis.handler.action(_zis.component, "remove_all");
          },
          noLabel: _zis.$vt("Cancel"),
        });
      });
    },
    refresh: function () {
      var _zis = this;
      this.pending = true;
      this.handler
        .action(this.component["#id"], "load_items")
        .then(function () {
          _zis.pending = false;
        });
    },
  },
  props: ["component", "handler"],
  data: function () {
    return {
      loading: false,
    };
  },
};
</script>
    
<template>
  <div class="vrun-form-result-page">
    <div class="f-actions">
      <f-button type="primary" @click="refresh()"
        >{{ $vt("Reload") }} <f-icon icon="fa6-rotate"></f-icon
      ></f-button>
      <f-button type="primary" :href="component.export_link"
        >{{ $vt("Export") }} <f-icon icon="fa6-export"></f-icon
      ></f-button>
      <f-button type="negative" @click="removeAll()"
        >{{ $vt("Remove all") }} <f-icon icon="fa6-trash"></f-icon
      ></f-button>
    </div>
    <div class="f-content">
      <div
        class="f-empty"
        v-if="
          !component.items.body ||
          Object.values(component.items.body).length == 0
        "
      >
        {{ $vt("No result yet") }}
      </div>
      <f-sexy-scroll
        v-if="
          !component.items.body ||
          Object.values(component.items.body).length > 0
        "
      >
        <table>
          <thead>
            <tr>
              <th v-for="header in component.items.header" :key="header['#id']">
                {{ header }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="line in component.items.body" :key="line['#id']">
              <td v-for="cell in line" :key="cell['#id']">
                <component :is="cell.directive" :value="cell.value"></component>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="more" @click="more()" v-if="component.more_to_load">
          <span v-if="!pending">
            {{ $vt("Load more") }} <f-icon icon="fa6-arrow-down"></f-icon>
          </span>
          <span v-if="pending">
            <f-icon spin icon="fa6-circle-notch"></f-icon>
          </span>
        </div>
      </f-sexy-scroll>
    </div>
  </div>
</template>

<style lang="scss">
.vrun-form-result-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;

  .f-actions {
    background-color: var(--black);
    border-radius: 8px;
    gap: 16px;
    display: flex;
    box-shadow: 0 4px 16px #1616151a;
    padding: 16px;
  }

  .f-content {
    background-color: var(--black);
    border-radius: 8px;
    gap: 16px;
    box-shadow: 0 4px 16px #1616151a;
    padding: 16px;
    height: 0;
    flex: 1 1 100%;
    .f-empty {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-style: italic;
      font-weight: bold;
      opacity: 0.5;
    }
    .f-sexy-scroll {
      height: 100%;
      table {
        border-collapse: collapse;
        thead {
          position: sticky;
          top: 0;
          z-index: 1;
          tr {
            th {
              flex: 1 1 auto;
              padding: 22px 16px;
              font-family: Lato;
              font-size: 14px;
              font-style: normal;
              font-weight: bold;
              line-height: 17px;
              text-transform: none;
              position: relative;

              // &:hover::after,
              // &.selected::after {
              //   content: "";
              //   width: 100%;
              //   height: 2px;
              //   background: linear-gradient(0deg, #1890d340, #1890d340), #fff;
              //   border-radius: 1px 1px 0 0;
              //   position: absolute;
              //   bottom: 0;
              //   left: 0;
              // }
            }
          }
        }
        tbody {
          tr {
            td {
              padding: 0;
            }
          }
        }
      }
      .more {
        cursor: pointer;
        border-radius: 4px;
        align-items: baseline;
        justify-content: center;
        padding: 8px 4px;
        font-size: 14px;
        line-height: 14px;
        display: flex;
        &:hover {
          background-color: #1890d31a;
        }
      }
    }
  }
}
</style>